// MenuIconRibbonButton.js

import { Button, Tooltip } from '@mui/material'
import ArticleTwoToneIcon from '@mui/icons-material/ArticleTwoTone'
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone'
import ThunderstormTwoToneIcon from '@mui/icons-material/ThunderstormTwoTone'
import NoteAddTwoToneIcon from '@mui/icons-material/NoteAddTwoTone'
import NearMeTwoToneIcon from '@mui/icons-material/NearMeTwoTone'
import DoDisturbRoundedIcon from '@mui/icons-material/DoDisturbRounded'
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded'

// Icon Menu buttons
const iconMenuButtonStyle = {
  paddingLeft:"0px", 
  marginLeft:'5px',
  marginTop: '5px',
  marginBottom: '5px', 
  height:"25px", 
  width:"0px", 
}

// Icon for "end edit" button
const Icon = () => {
  return (
    <span
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "Center",
        alignItems: "Center",
        marginLeft: "5px"
      }}
    >
      <DoDisturbRoundedIcon style={{position: 'absolute'}} fontSize="12" />
      <ModeEditRoundedIcon style={{position: 'absolute'}} fontSize="18" />
    </span>
  )
}

/**
 * 
 * @param {function} setSwmmInp sets the filename for the current model
 * @param {string} swmmTxt current model's .inp file contents
 * @param {function} setOpenRptText sets the 'display' state of the rpt dialog window.
 * @param {function} setEditType sets the type of editing that will be performed after clicking a button.
 * @param {function} setModelRun sets a flag that tells the main program to 'run' a model.
 * @param {boolean} loadNew if true, shows a menu option for loading new files.
 * @returns a set of icon buttons for primary interaction functions.
 */
export default function MenuIconRibbonButtons({setSwmmInp, swmmTxt, setOpenRptText, setEditType, setModelRun, loadNew}){
  
  function saveInpFile(content, filename, contentType) {
    const blob = new Blob([content], { type: contentType })
  
    const downloadLink = document.createElement('a')
    downloadLink.href = URL.createObjectURL(blob)
    downloadLink.download = filename
  
    // Append the download link to the document body and simulate a click
    document.body.appendChild(downloadLink)
    downloadLink.click()
  
    // Clean up the temporary download link
    document.body.removeChild(downloadLink)
  }

  let buttonArray = [
    loadNew && {title: 'New model',   icon: <NoteAddTwoToneIcon />,      onClick: ()=>{setSwmmInp('newFile')}},
    {title: 'Save model',  icon: <SaveTwoToneIcon />,         onClick: ()=>{saveInpFile(swmmTxt, 'model.inp', 'text/plain')}},
    {title: 'View report', icon: <ArticleTwoToneIcon />,      onClick: ()=>{setOpenRptText(true)}},
    {title: 'Select/Edit', icon: <NearMeTwoToneIcon />,       onClick: ()=>{setEditType(100)}},
    {title: 'End edit',    icon: <Icon />,                    onClick: ()=>{setEditType(0)}},
    {title: 'Run model',   icon: <ThunderstormTwoToneIcon />, onClick: ()=>{setModelRun(prev=>prev+1)}},
  ]

  return (
    <>
    {
      buttonArray.map((element, index)=> {
        if(element){
          return (
            <Tooltip title={element.title} arrow key={element.title + index}>
              <Button color="buttonColor" variant="contained" style={iconMenuButtonStyle} endIcon={element.icon} onClick={element.onClick} />
            </Tooltip>)
        } else
        {
          return null
        }
      })
    }
    </>
  )
}